import { CSSProperties, useEffect, useMemo, useState } from 'react'

export const calculateTimeToExpiration = (expireTime: Date) => {
  const timeFromNow = Math.floor(
    (expireTime.valueOf() - new Date().valueOf()) / 1000
  )
  if (timeFromNow > 0) return timeFromNow
  return 0
}
export const formatSeconds = (numSeconds: number) => {
  const minutes = `${Math.floor(numSeconds / 60)}`
  const seconds = `${numSeconds % 60}`.padStart(2, '0')
  return `${minutes}:${seconds}`
}

export const useExpiration = (
  duration: number,
  expireTime: Date,
  stopped?: boolean
) => {
  const [timeToExpiration, setTimeToExpiration] = useState(
    calculateTimeToExpiration(expireTime)
  )
  useEffect(() => {
    if (!stopped && timeToExpiration > 0) {
      const interval = setInterval(() => {
        setTimeToExpiration(calculateTimeToExpiration(expireTime))
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [duration, expireTime, stopped, timeToExpiration])
  const displayTime = formatSeconds(timeToExpiration)
  const fraction = timeToExpiration / duration
  const barStyle = useMemo(() => {
    if (stopped) {
      return undefined
    }
    return {
      ['--countdownWidth']: `${fraction * 100}%`
    } as CSSProperties
  }, [fraction, stopped])
  return { timeToExpiration, displayTime, fraction, barStyle }
}
